import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { CheckAccessHelper } from 'core/classes/helpers/CheckAccessHelper'
import { ADMIN } from 'core/constants/roles'

import { TRANSLATION_KEYS } from '../../translations'

interface IAddNewGlobalPartnerProps {
  onClick: () => void
  className?: string
}

export const AddNewGlobalPartner = ({ onClick, className }: IAddNewGlobalPartnerProps) => {
  const user = useSelector(selectUser)

  const isSuperAdmin = useMemo(() => {
    return CheckAccessHelper(user.roleIds, [ADMIN])
  }, [user.roleIds])

  if (!isSuperAdmin) {
    return null
  }
  return (
    <div className={className}>
      <Button margin={'md'} onClick={onClick}>
        <Translation text={TRANSLATION_KEYS.addNewGlobalPartner}></Translation>
      </Button>
    </div>
  )
}
